import React from 'react'

export type TbodyProps = React.HTMLAttributes<HTMLTableSectionElement>

const Tbody = React.forwardRef<HTMLTableSectionElement, TbodyProps>(
  ({ children }, ref) => {
    return (
      <tbody ref={ref} className="text-sm bg-white divide-y divide-gray-200">
        {children}
      </tbody>
    )
  }
)

export default Tbody
